import { api } from '../../api';

export const dailyMetricsService = {
  getDailyMetrics,
  getDailyMetricDates,
  getDailyMetricDatesByRange,
};

// Naming of this is confusing - it fetches the daily params for display on the card
// for a daily metric, which is why it needs /passive as it exists on a different controller
function getDailyMetrics(patientId: string, date: Date) {
  return api.get(`/passive/dailyMetrics?patientId=${patientId}&date=${date}`);
}

function getDailyMetricDates(patientId: string) {
  return api.get(`/dailymetrics/dates/${patientId}`);
}

function getDailyMetricDatesByRange(
  patientId: string,
  startDate: string,
  endDate: string
) {
  return api.get(
    `/dailymetrics/dates/range?accountGuid=${patientId}&dateStart=${startDate}&dateEnd=${endDate}`
  );
}
